export const createHeadline = ({ headlineTitle }) => headlineTitle || 'Opticians';
